var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              staticClass: "btn-info btn--bigger",
              attrs: { type: "button" },
              on: { click: _vm.consultar }
            },
            [
              _c("i", { staticClass: "fa fa-search" }),
              _vm._v(" "),
              _c("span", [_vm._v("Consultar")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-success btn--bigger",
              attrs: { type: "button" },
              on: { click: _vm.exportarExcel }
            },
            [
              _c("i", { staticClass: "fa fa-file-excel-o" }),
              _vm._v(" "),
              _c("span", [_vm._v("Excel")])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-danger btn--bigger",
              attrs: { type: "button" },
              on: { click: _vm.exportarPDF }
            },
            [
              _c("i", { staticClass: "fa fa-file-pdf-o" }),
              _vm._v(" "),
              _c("span", [_vm._v("PDF")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-2" }, [
            _c("p", [
              _c("label", { attrs: { for: "sinPersonas" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.sin_personas,
                      expression: "form.sin_personas"
                    }
                  ],
                  attrs: {
                    type: "checkbox",
                    name: "sinPersonas",
                    id: "sinPersonas"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.form.sin_personas)
                      ? _vm._i(_vm.form.sin_personas, null) > -1
                      : _vm.form.sin_personas
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.form.sin_personas,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.form,
                              "sin_personas",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "sin_personas",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "sin_personas", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Sin personas")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.form.sin_personas,
                  expression: "!form.sin_personas"
                }
              ],
              staticClass: "col-xs-12 col-md-5"
            },
            [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        placeholder: "Seleccione...",
                        id: "persona",
                        options: _vm.personas,
                        label: "nombre"
                      },
                      on: { input: _vm.inputPersona },
                      model: {
                        value: _vm.selectedPersona,
                        callback: function($$v) {
                          _vm.selectedPersona = $$v
                        },
                        expression: "selectedPersona"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "persona" } }, [
                      _vm._v("Persona")
                    ])
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-5" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      placeholder: "Seleccione...",
                      id: "vendedor",
                      options: _vm.vendedores,
                      label: "nombre"
                    },
                    on: { input: _vm.inputVendedor },
                    model: {
                      value: _vm.selectedVendedor,
                      callback: function($$v) {
                        _vm.selectedVendedor = $$v
                      },
                      expression: "selectedVendedor"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "vendedor" } }, [
                    _vm._v("Vendedor")
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 mt-2" }, [
            _c("div", { staticClass: "form-inline" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("label", { attrs: { for: "abiertas" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.estado,
                      expression: "form.estado"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "estado",
                    id: "abiertas",
                    value: "A"
                  },
                  domProps: { checked: _vm._q(_vm.form.estado, "A") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.form, "estado", "A")
                      },
                      _vm.consultar
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Abiertas")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "asignadas" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.estado,
                      expression: "form.estado"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "estado",
                    id: "asignadas",
                    value: "V"
                  },
                  domProps: { checked: _vm._q(_vm.form.estado, "V") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.form, "estado", "V")
                      },
                      _vm.consultar
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Asignadas")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "facturables" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.estado,
                      expression: "form.estado"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "estado",
                    id: "facturables",
                    value: "B"
                  },
                  domProps: { checked: _vm._q(_vm.form.estado, "B") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.form, "estado", "B")
                      },
                      _vm.consultar
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Facturables")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "facturadas" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.estado,
                      expression: "form.estado"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "estado",
                    id: "facturadas",
                    value: "F"
                  },
                  domProps: { checked: _vm._q(_vm.form.estado, "F") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.form, "estado", "F")
                      },
                      _vm.consultar
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Facturadas")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "cerradas" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.estado,
                      expression: "form.estado"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "estado",
                    id: "cerradas",
                    value: "C"
                  },
                  domProps: { checked: _vm._q(_vm.form.estado, "C") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.form, "estado", "C")
                      },
                      _vm.consultar
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Cerradas")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "anuladas" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.estado,
                      expression: "form.estado"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "estado",
                    id: "anuladas",
                    value: "E"
                  },
                  domProps: { checked: _vm._q(_vm.form.estado, "E") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.form, "estado", "E")
                      },
                      _vm.consultar
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Anuladas")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "todas" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.estado,
                      expression: "form.estado"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "estado",
                    id: "todas",
                    value: "T"
                  },
                  domProps: { checked: _vm._q(_vm.form.estado, "T") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.form, "estado", "T")
                      },
                      _vm.consultar
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Todas")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 mt-2" }, [
            _c("div", { staticClass: "form-inline" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("label", { attrs: { for: "hoy" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipo_fecha,
                      expression: "form.tipo_fecha"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "tipo_fecha",
                    id: "hoy",
                    value: "H"
                  },
                  domProps: { checked: _vm._q(_vm.form.tipo_fecha, "H") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.form, "tipo_fecha", "H")
                      },
                      _vm.consultar
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Hoy")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "ayer" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipo_fecha,
                      expression: "form.tipo_fecha"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "tipo_fecha",
                    id: "ayer",
                    value: "A"
                  },
                  domProps: { checked: _vm._q(_vm.form.tipo_fecha, "A") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.form, "tipo_fecha", "A")
                      },
                      _vm.consultar
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Ayer")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "rango" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipo_fecha,
                      expression: "form.tipo_fecha"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "tipo_fecha",
                    id: "rango",
                    value: "P"
                  },
                  domProps: { checked: _vm._q(_vm.form.tipo_fecha, "P") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.form, "tipo_fecha", "P")
                      },
                      _vm.changePersonalizado
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Personalizado")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipo_fecha === "P",
                      expression: "form.tipo_fecha === 'P'"
                    }
                  ],
                  staticClass: "form-field"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "datepicker-field datepicker-field--stretch"
                    },
                    [
                      _c("date-picker", {
                        attrs: { type: "date", id: "desde" },
                        model: {
                          value: _vm.form.desde,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "desde", $$v)
                          },
                          expression: "form.desde"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Desde")])
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipo_fecha === "P",
                      expression: "form.tipo_fecha === 'P'"
                    }
                  ],
                  staticClass: "form-field"
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.tipo_fecha === "P",
                          expression: "form.tipo_fecha === 'P'"
                        }
                      ],
                      staticClass: "datepicker-field datepicker-field--stretch"
                    },
                    [
                      _c("date-picker", {
                        attrs: { name: "hasta", type: "date", id: "hasta" },
                        model: {
                          value: _vm.form.hasta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "hasta", $$v)
                          },
                          expression: "form.hasta"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Hasta")])
                    ],
                    1
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 mt-2" }, [
            _c("div", { staticClass: "form-inline" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("label", { attrs: { for: "conProforma" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.con_proforma,
                      expression: "form.con_proforma"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "conProforma",
                    id: "conProforma",
                    value: "C"
                  },
                  domProps: { checked: _vm._q(_vm.form.con_proforma, "C") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.form, "con_proforma", "C")
                      },
                      _vm.consultar
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Con proforma")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "sinProforma" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.con_proforma,
                      expression: "form.con_proforma"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "conProforma",
                    id: "sinProforma",
                    value: "S"
                  },
                  domProps: { checked: _vm._q(_vm.form.con_proforma, "S") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.form, "con_proforma", "S")
                      },
                      _vm.consultar
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Sin proforma")])
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "ambos" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.con_proforma,
                      expression: "form.con_proforma"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "conProforma",
                    id: "ambos",
                    value: "A"
                  },
                  domProps: { checked: _vm._q(_vm.form.con_proforma, "A") },
                  on: {
                    change: [
                      function($event) {
                        return _vm.$set(_vm.form, "con_proforma", "A")
                      },
                      _vm.consultar
                    ]
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Ambos")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c(
                    "input-field",
                    {
                      attrs: {
                        id: "numeroProforma",
                        placeholder: "Digite un número..."
                      },
                      model: {
                        value: _vm.form.numero_proforma,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "numero_proforma", $$v)
                        },
                        expression: "form.numero_proforma"
                      }
                    },
                    [_c("span", [_vm._v("Número de proforma")])]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c(
                    "input-field",
                    {
                      attrs: {
                        id: "numero_orden_trabajo",
                        placeholder: "Digite un número..."
                      },
                      model: {
                        value: _vm.form.numero_orden_trabajo,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "numero_orden_trabajo", $$v)
                        },
                        expression: "form.numero_orden_trabajo"
                      }
                    },
                    [_c("span", [_vm._v("Número de orden de trabajo")])]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-field" }, [
                _c("label", { attrs: { for: "conDetalle" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.conDetalle,
                        expression: "form.conDetalle"
                      }
                    ],
                    attrs: {
                      type: "checkbox",
                      name: "conDetalle",
                      id: "conDetalle"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.form.conDetalle)
                        ? _vm._i(_vm.form.conDetalle, null) > -1
                        : _vm.form.conDetalle
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.form.conDetalle,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.form,
                                "conDetalle",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.form,
                                "conDetalle",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.form, "conDetalle", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Con detalles")])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card mt-2" }, [
      _vm._m(5),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c(
          "div",
          { staticClass: "table-responsive" },
          [
            _c("vue-good-table", {
              attrs: {
                "row-style-class": _vm.rowStyleClassFn,
                columns: [
                  {
                    label: "Fecha de emisión",
                    field: "fecha_emision",
                    filterable: true
                  },
                  {
                    label: "Persona",
                    field: "nombre_persona",
                    filterable: true
                  },
                  {
                    label: "Número de proforma",
                    field: "numero_proforma",
                    filterable: true
                  },
                  {
                    label: "Número de documento",
                    field: "numero_documento",
                    filterable: true
                  },
                  {
                    label: "Asignado",
                    field: "nombre_vendedor",
                    filterable: true
                  },
                  {
                    label: "Detalles",
                    field: "detalles",
                    filterable: false,
                    hidden: !_vm.form.conDetalle
                  },
                  {
                    label: "Costo total",
                    field: "costo_total",
                    filterable: true
                  },
                  {
                    label: "Estado",
                    field: "descripcion_estado",
                    filterable: true
                  },
                  {
                    label: "Observación",
                    field: "observacion",
                    filterable: true
                  }
                ],
                "pagination-options": {
                  enabled: true,
                  perPage: 10,
                  nextLabel: "siguiente",
                  prevLabel: "anterior",
                  rowsPerPageLabel: "Registros por página",
                  ofLabel: "de",
                  allLabel: "Todo"
                },
                rows: _vm.ordenesTrabajo,
                "search-options": {
                  enabled: true,
                  placeholder: "Buscar..."
                },
                styleClass: "vgt-table"
              },
              scopedSlots: _vm._u([
                {
                  key: "table-row",
                  fn: function(props) {
                    return [
                      props.column.field == "detalles"
                        ? _c("span", [
                            _c("div", { staticClass: "table-responsive" }, [
                              _c("table", [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [_vm._v("ítem")]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Cantidad")]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Costo")]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Costo total")])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  [
                                    _vm._l(props.row.detalles, function(
                                      detalle
                                    ) {
                                      return _c("tr", { key: detalle.id }, [
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(detalle.descripcion_item)
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.decimalFormat(
                                                detalle.cantidad
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.moneyFormat(detalle.costo)
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.moneyFormat(
                                                detalle.costo_total
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "tr",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              props.row.detalles.length === 0,
                                            expression:
                                              "props.row.detalles.length === 0"
                                          }
                                        ]
                                      },
                                      [
                                        _c("td", { attrs: { colspan: "3" } }, [
                                          _c("strong", [
                                            _vm._v("No hay detalles.")
                                          ])
                                        ])
                                      ]
                                    )
                                  ],
                                  2
                                )
                              ])
                            ])
                          ])
                        : props.column.field == "numero_documento"
                        ? _c("span", [
                            _c(
                              "button",
                              {
                                staticClass: "btn-info btn--text",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.verOrdenTrabajo(props.row)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    props.row.tipo_documento +
                                      props.row.numero_documento
                                  )
                                )
                              ]
                            )
                          ])
                        : props.column.field == "numero_proforma"
                        ? _c("span", [
                            _c(
                              "button",
                              {
                                staticClass: "btn-info btn--text",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.verProforma(props.row)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(props.row.numero_proforma))]
                            )
                          ])
                        : props.column.field == "costo_total"
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.moneyFormat(props.row.costo_total))
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              _vm._s(props.formattedRow[props.column.field])
                            )
                          ])
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Reporte de órdenes de trabajo")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Filtros")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Filtros por estado")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Filtros por fecha")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("strong", [_vm._v("Filtros de comprobante")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Resultados de la consulta")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32f655dc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32f655dc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/ordenes-trabajo/ReporteOrdenesTrabajo.vue
// module id = 595
// module chunks = 0